export default {
  title: 'ProPush Settings',

  widgets: {
    title: 'Widgets',

    titles: {
      create: 'Create Widget',
      settings: 'Settings',
      channels: 'Channels'
    },

    labels: {
      name: 'Name',
      isActive: 'Is Active',
      isBlocked: 'Is Blocked',
      owner: 'Owner',
      channels: 'Channels'
    },

    hints: {
      notFound: 'No widgets found',
      channels: 'To successfully attach channels to the widget, you need to select the required channels and click the "Attach" button.'
    },

    tooltips: {
      isActive: {
        true: 'Widget is active',
        false: 'Widget is not active'
      },

      isBlocked: {
        true: 'Widget is blocked by the administrator'
      }
    },

    infos: {
      channels: 'To make the widget work correctly, it is necessary to attach channels to it.<br>To do this, select the required channels and click the "Save" button.',
      ipWhitelist: 'In the IP address field, you can specify addresses or CIDR ranges from which requests to the system are allowed.<br>If you specify <b>0.0.0.0/0</b>, access will be open for all IP addresses.',

      user: {
        channels: 'To make the user widget work correctly, it is necessary to allow it to use specific channels.<br>To do this, select the required channels and click the "Save" button.'
      }
    },

    warnings: {
      channels: 'No available active channels. Please contact support.'
    },

    snackbars: {
      created: 'Widget has been created',
      updated: 'Widget has been updated',
      removed: 'Widget has been removed',

      channels: {
        attached: 'Channels have been attached'
      }
    }
  },

  channels: {
    title: 'Channels',

    titles: {
      create: 'Create Channel',
      templates: 'Templates',

      additionalSettings: {
        title: 'Additional Settings',
        code: 'Code Settings'
      }
    },

    labels: {
      name: 'Name',
      channelType: 'Channel Type',
      templates: 'Templates',

      additionalSettings: {
        code: {
          length: 'Code Length',
          beautify: 'Beautify Code'
        },
        lifetime: 'Code Lifetime, sec',
        numberOfTries: 'Number of code entry attempts',
        numberOfRestart: 'Maximum number of channel restarts',
        mtsClientId: 'MTS Client ID'
      }
    },

    hints: {
      notFound: 'No channels found',
      templates: 'To successfully attach templates to the channel, you need to select the required templates and click the "Attach" button.',
      additionalSettings: 'Lifetime and number of tries should be greater than 0'
    },

    infos: {
      templates: 'To make the channel work correctly, it is necessary to attach templates to it.<br>To do this, select the required templates and click the "Save" button.'
    },

    warnings: {
      templates: 'No available templates.'
    },

    snackbars: {
      created: 'Channel has been created',
      updated: 'Channel has been updated',
      removed: 'Channel has been removed',

      templates: {
        attached: 'Templates have been attached'
      }
    }
  },

  templates: {
    title: 'Templates',

    titles: {
      create: 'Create Template',
      conditions: 'Conditions'
    },

    labels: {
      name: 'Name',
      channelType: 'Channel Type',

      additionalSettings: {
        senderId: 'Sender',
        template: 'Template'
      }
    },

    hints: {
      notFound: 'No templates found',

      additionalSettings: {
        template: 'For code substitution use {{ code }}'
      }
    },

    snackbars: {
      created: 'Template has been created',
      updated: 'Template has been updated',
      removed: 'Template has been removed'
    }
  }
}
